import SidePanelHeader from "../components/SidePanelHeader"
import { useNavigate } from "react-router"
import * as Navigation from "../../../../../modules/Navigation";
import SidePanelInfo from "../components/SidePanelInfo"
import EditAction from "../actions/EditAction";
import ActionBar from "../actions/ActionBar";
import SidePanelBreadCrumb from "../components/SidePanelBreadCrumb";
import { Button } from "react-aria-components";
import { httpDelete } from "../../../../../modules/Backend";
import { HttpStatusCode } from "axios";
import { globalSubmittingSignal, globalUpdateResultsSignal } from "../../Layout";
import { modalSignal } from "../../../Modal/ModalContainer";
import ConfirmModal, { ConfirmType } from "../../../Modal/ConfirmModal";
import { useEffect, useState } from "react";

export default function SidePanelLocations({ data, onViewPage }: any) {
    const navigate = useNavigate()
    const [currentData, setCurrentData] = useState<Record<string, any>>(data);

    useEffect(() => {
        setCurrentData(data);
    }, [data]);

    function viewEntity() {
        Navigation.view.navigate(navigate, currentData.entityName, currentData.id, currentData)
    }

    async function toggleDeleteLocation() {
        const payload = { id: currentData.id };
        const result = await httpDelete(`api/${currentData.entityName}/toggleDelete`, payload);

        if (result?.status === HttpStatusCode.Ok) {
            const nextIsDeleted = !currentData.isDeleted;
            setCurrentData({
                ...currentData,
                isDeleted: nextIsDeleted
            });

            globalUpdateResultsSignal.value = {
                id: currentData.id,
                updateChanges: {
                    isDeleted: nextIsDeleted
                }
            };

            if (onViewPage) {
                navigate(-1);
            }
        }
    }

    function handleToggleDeleteLocation() {
        const isDeleted = currentData.isDeleted === true;
        modalSignal.value = <ConfirmModal
            heading={isDeleted ? "Restore location?" : "Delete location?"}
            information={isDeleted
                ? "This will make the location present in move to location"
                : "Deleted locations will still show in historic audit trails, but will not be present in move to location"}
            ContinueFunc={toggleDeleteLocation}
            type={ConfirmType.Destructive}
        />
    }

    return (<>
        {currentData &&
            <>
                {!onViewPage && <SidePanelHeader descriptor="" statuses={[]} value={currentData.name} onClick={(() => { viewEntity() })} />}
                <ActionBar>
                    <EditAction id={currentData.id} entityName={currentData.entityName} />
                    <Button
                        isDisabled={globalSubmittingSignal.value.isBusy}
                        className={currentData.isDeleted
                            ? "button button--small button--secondary button--with-icon"
                            : "button button--small button--secondary button--secondary--destructive button--with-icon"}
                        onPress={handleToggleDeleteLocation}
                    >
                        <p className="button-text">{currentData.isDeleted ? "Undelete" : "Delete"}</p>
                    </Button>
                </ActionBar>
                {currentData.breadcrumb && <SidePanelBreadCrumb descriptor="Current" value={currentData.breadcrumb} />}
                <SidePanelInfo
                    values={[
                        { label: "Type", value: currentData.locationTypeName },
                        { label: "Level", value: currentData.level?.toString() },
                    ]}
                />
            </>
        }
    </>)
}
